"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const aes_js_1 = __importDefault(require("aes-js"));
const secp256k1_1 = __importDefault(require("secp256k1"));
const getRandomValues = () => {
    return window.crypto.getRandomValues(new Uint8Array(32));
};
// Generate the shared key that bridges two keypairs
const getSharedKey = (privateKey, publicKey) => {
    const hashfn = (x, y) => {
        const pubKey = new Uint8Array(33);
        pubKey[0] = (y[31] & 1) === 0 ? 0x02 : 0x03;
        pubKey.set(x, 1);
        return pubKey;
    };
    return secp256k1_1.default.ecdh(publicKey, privateKey, { hashfn }, Buffer.alloc(33));
};
const encrypt = (key, message, toHex = true) => {
    key = key.subarray(0, 32);
    const aesCtr = new aes_js_1.default.ModeOfOperation.ctr(key);
    const enc = aesCtr.encrypt(message);
    return toHex ? aes_js_1.default.utils.hex.fromBytes(enc) : enc;
};
const decrypt = (key, message, toUtf8 = true) => {
    key = key.subarray(0, 32);
    const aesCtr = new aes_js_1.default.ModeOfOperation.ctr(key);
    message =
        typeof message === "string" ? aes_js_1.default.utils.hex.toBytes(message) : message;
    const dec = aesCtr.decrypt(message);
    return toUtf8 ? aes_js_1.default.utils.utf8.fromBytes(dec) : dec;
};
const EncryptionModule = {
    getRandomValues,
    getSharedKey,
    encrypt,
    decrypt,
};
exports.default = EncryptionModule;
